(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabScheduleController', TabScheduleController);

    TabScheduleController.$inject = ['$state', 'TabSchedule', 'ParseLinks', 'AlertService', 'pagingParams', '$scope', '$filter', 'paginationConstants'];

    function TabScheduleController($state, TabSchedule, ParseLinks, AlertService, pagingParams, $scope, $filter, paginationConstants) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.predicates = {scheduleDatetime: false};
        vm.transition = transition;
        vm.charToSearch = pagingParams.search;
        vm.currentState = "tab-schedule";
        vm.currentStateFilter = "tab-schedule-filter";
        vm.fleet = pagingParams.fleet;
        vm.objectType = pagingParams.objectType;
        vm.from = pagingParams.from;
        vm.to = pagingParams.to;
        vm.status = pagingParams.status;
        vm.tag = pagingParams.tag;
        vm.searchText = pagingParams.ch;
        vm.firstAccess = pagingParams.firstAccess;
        vm.applyFilter = applyFilter;
        vm.picker = {
            start: false,
            end: false
        };

        var filter = localStorage.getItem(vm.currentStateFilter);
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);

        if (filter !== null && filter !== "null" && filter !== undefined) {
            filter = JSON.parse(filter);
            if (Object.keys(filter).length > 0) {
                vm.fleet = filter.fleet;
                vm.objectType = filter.objectType;
                vm.from = filter.from;
                vm.to = filter.to;
                vm.status = filter.status;
            }
        }

        if (vm.firstAccess == true) {
            localStorage.setItem("first-access", JSON.stringify({firstAccess: false}));
        } else {
            localStorage.setItem("first-access", JSON.stringify({firstAccess: true}));
        }

        Chart.plugins.register({
            beforeRender: function (chart) {
                if (chart.config.options.showAllTooltips) {
                    // create an array of tooltips
                    // we can't use the chart tooltip because there is only one tooltip per chart
                    chart.pluginTooltips = [];
                    chart.config.data.datasets.forEach(function (dataset, i) {
                        chart.getDatasetMeta(i).data.forEach(function (sector, j) {
                            chart.pluginTooltips.push(new Chart.Tooltip({
                                _chart: chart.chart,
                                _chartInstance: chart,
                                _data: chart.data,
                                _options: chart.options.tooltips,
                                _active: [sector]
                            }, chart));
                        });
                    });
                    // turn off normal tooltips
                    chart.options.tooltips.enabled = false;
                }
            },
            afterDraw: function (chart, easing) {
                if (chart.config.options.showAllTooltips) {
                    // we don't want the permanent tooltips to animate, so don't do anything till the animation runs atleast once
                    if (!chart.allTooltipsOnce) {
                        if (easing !== 1)
                            return;
                        chart.allTooltipsOnce = true;
                    }
                    chart.getDatasetMeta(0).data.forEach(function (data) {
                        for (var i = 0; i < data._chart.config.data.datasets[0].data.length; ++i) {
                            chart.getDatasetMeta(0).data[i].hidden = data._chart.config.data.datasets[0].data[i] === 0;
                        }
                    });
                    // turn on tooltips
                    chart.options.tooltips.enabled = true;
                    Chart.helpers.each(chart.pluginTooltips, function (tooltip) {
                        // This line checks if the item is visible to display the tooltip
                        if(!tooltip._active[0].hidden){
                            tooltip.initialize();
                            tooltip.update();
                            tooltip.transition(easing).draw();
                        }
                    });
                    chart.options.tooltips.enabled = false;
                }
                chart.update();
            }
        });

        $scope.options = {
            legend: {display: true, position: 'right'},
            title: {display: true, fontSize: 12, text: "Updates Schedules Status", position: "left"},
            showAllTooltips: true,
            tooltips: {
                callbacks: {
                    label: function (tooltipItem, data) {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                    }
                }
            }
        };

        //Aggiunta per impaginazione
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;


        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll = function () {
            var page = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(),
                ch: vm.searchText
            };
            addFilter(page);
            TabSchedule.query(page,  onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tabSchedules = data;
                vm.page = pagingParams.page;
                // transition();
                $scope.dataSchedules = [];
                $scope.labelsSchedules = [];
                $scope.colorsSchedules = [];
                vm.done = [];
                vm.error = [];
                vm.duplicated = [];
                vm.other = [];
                data.forEach( function (d) {
                    if (d.scheduleStatus.scheduleStatusName === "done")
                        vm.done.push(d);
                    else if (d.scheduleStatus.scheduleStatusName === "error")
                        vm.error.push(d);
                    else if (d.scheduleStatus.scheduleStatusName === "duplicated")
                        vm.duplicated.push(d);
                    else vm.other.push(d);
                });

                $scope.dataSchedules.push(vm.done.length);
                $scope.labelsSchedules.push("done");
                $scope.colorsSchedules.push('#26C281');

                $scope.dataSchedules.push(vm.error.length);
                $scope.labelsSchedules.push("error");
                $scope.colorsSchedules.push('#E43A45');

                $scope.dataSchedules.push(vm.duplicated.length);
                $scope.labelsSchedules.push("duplicated");
                $scope.colorsSchedules.push('#F3C200');

                $scope.dataSchedules.push(vm.other.length);
                $scope.labelsSchedules.push("other");
                $scope.colorsSchedules.push('#C3C3C3');

                vm.emptyData = $scope.dataSchedules.filter(function (value) {
                    return value > 0;
                });

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            localStorage.setItem("save-filter", JSON.stringify({from: vm.from, to: vm.to,fleet: vm.fleet,objectType: vm.objectType, status: vm.status, tag: vm.tag }));
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                itemsPerPageChosen: vm.itemsPerPageChosen,
                search: vm.charToSearch,
                fleet: vm.fleet,
                objectType: vm.objectType,
                from: vm.from,
                to: vm.to,
                status: vm.status,
                tag: vm.tag,
                ch: vm.searchText,
                firstAccess: false
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };

        function applyFilter(fleet, objectType, from, to, status, tag) {
            var filter = {};
            filter.fleet = vm.fleet = fleet;
            filter.objectType = vm.objectType = objectType;
            filter.from = vm.from = from;
            filter.to = vm.to = to;
            filter.status = vm.status = status;
            filter.tag = vm.tag = tag;
            localStorage.setItem(vm.currentStateFilter, JSON.stringify(filter));
            vm.loadAll();
        }

        var dateFormat = 'yyyy-MM-dd HH:mm';
        function addFilter(body) {
            if (+vm.fleet.id !== -1)
                body.fleetId = vm.fleet.id;
            if (+vm.objectType.id !== -1)
                body.objectTypeId = vm.objectType.id;
            if (vm.from !== null)
                body.from = $filter('date')(vm.from, dateFormat);
            if (vm.to !== null)
                body.to = $filter('date')(vm.to, dateFormat);
            if (+vm.status.id !== -1)
                body.statusId = vm.status.id;
            if (vm.tag !== null) {
                body.tag = vm.tag;
            }

        }

        vm.loadAll();
    }
})();
